<template>
  <md-card v-if="show != null">
    <md-card-header v-if="header && header.length > 0">
      <h1 class="md-title">{{ header }}</h1>
    </md-card-header>

    <md-card-content>
      <table>
        <tr v-for="item in show">
          <td class="tdKey">{{ item.key }}</td>
          <td class="tdVal">
            <span>{{ item.value }}</span>
          </td>
        </tr>
      </table>
    </md-card-content>
  </md-card>
</template>

<script>
  const _pc = {
    name: 'prop-card',
    props: {
      header: String,
      data: Object
    },
    data: () => ({
      show: null
    }),
    methods: {
      update: function() {
        if (this.data) {
          this.show = Object.entries(this.data).map(ar => ({ key: ar[0], value: ar[1] }));
        } else {
          this.show = null;
        }
      }
    },
    created() {
      this.update();
    },
    watch: {
      data: function (newVal, oldVal) {
        this.update();
      }
    }
  };
  
  export default _pc;
</script>

<style scoped>
  .tdKey {
    font-weight: bold;
    vertical-align: top;
    padding-right: 5pt;
  }
  .tdVal {
    white-space: pre;
  }
</style>



// WEBPACK FOOTER //
// src/components/PropCard.vue